module.exports = __webpack_public_path__ + "static/media/close-button.cd9886f7.svg";